import { Target } from '../@types';

const targetsForBooking: Target[] = [
  {
    value: 'presentableId',
    type: 'text',
    isAPI: true,
    queryName: 'bookingCode',
  },
  { value: 'status', type: 'selection', isAPI: true, queryType: 'array' },
  { value: 'type', type: 'text', isAPI: false },
  {
    value: 'from',
    type: 'date',
    isAPI: true,
    queryNameFrom: 'startFrom',
    queryNameTo: 'startTo',
  },
  {
    value: 'to',
    type: 'date',
    isAPI: true,
    queryNameFrom: 'endFrom',
    queryNameTo: 'endTo',
  },
  { value: 'plate', type: 'text', isAPI: true, queryName: 'carPlate' },
  { value: 'tripCode', type: 'text', isAPI: true },
  { value: 'userReferralCode', type: 'text', isAPI: true },
  {
    value: 'fleetId',
    type: 'selection',
    isAPI: true,
    queryName: 'fleets',
    queryType: 'array',
  },
  {
    value: 'brandId',
    type: 'selection',
    isAPI: true,
    queryName: 'brands',
    queryType: 'array',
  },
];

export default targetsForBooking;
